const moment = require('moment-timezone');

module.exports = {
  TENANT: 'wmus',
  APP_ENV: 'qa',
  URL_BASE: 'https://mls-wmus.qa.bnservers.com',
  PINGFED_BASE: 'https://pfedcert.wal-mart.com',
  REDIRECT_URL: 'https://mls-wmus-admin.qa.bnservers.com/',
  LOGGLY_TOKEN: '4a7408b2-648f-40f5-ab4b-c72ab8f11b63',
  DEFAULT_LANGUAGE: 'en',
  ALL_LANGUAGES: ['en', 'es'],
  MENU_ITEMS: [
    'Video Review',
    'Users',
    'Social Champs',
    'Stores',
    'Priorities',
    'Stickers',
    'Templates',
    'Post of the Day',
    'PowerBI',
    'Store Photos',
  ],
  getWalmartWeek: (date) => {
    const targetDate = moment(date);
    let walmartFirstSaturday = moment(
      `${targetDate.format('YYYY')}-02-02`,
      'YYYY-DD-MM'
    )
      .day(0)
      .isoWeekday(6);
    let dateDiff = targetDate.diff(walmartFirstSaturday, 'days');

    if (dateDiff < 0) {
      walmartFirstSaturday = moment(
        `${targetDate.format('YYYY') - 1}-02-02`,
        'YYYY-DD-MM'
      )
        .day(0)
        .isoWeekday(6);
      dateDiff = targetDate.diff(walmartFirstSaturday, 'days');
    }

    return Math.floor(dateDiff / 7) + 1;
  },
  getWMWeekStartDates: (currentDate) => {
    // this doesn't subtract an even 7 because WMUS/WMCA/SCUS weeks run Sat-Fri
    return {
      previous_week: moment(currentDate)
        .startOf('week')
        .subtract(8, 'days')
        .format(),
      current_week: moment(currentDate)
        .startOf('week')
        .subtract(1, 'day')
        .format(),
      next_week: moment(currentDate).startOf('week').add(6, 'days').format(),
    };
  },
};
